/**
 * BeforeSend: This function is called with an SDK-specific message or error event object, and can return a modified event object, or
 null to skip reporting the event. This can be used, for instance, for manual PII stripping before sending.
 https://docs.sentry.io/platforms/dotnet/guides/aspnetcore/configuration/options/#before-send
 *
 */
export const BLACK_LIST_HANDLED_ERROR_NAMES = [
    'InvalidSignatureException',
    'totalRetryDelay',
    'timeout of 10000ms exceeded',
    "Can't find variable: iom",
    "Can't find variable: stopYouTubeVideos",
    'Window closed for postrobot_method before ack',
    "Can't find variable: clickPauseText2SpeechButton",
    'Right side of assignment cannot be destructured',
    'The object can not be cloned.',
    "undefined is not an object (evaluating 't.default')",
    'Data Collector must be created with Kount and/or PayPal.',
    "Can't find variable: PaymentAutofillConfig",
    "null is not an object (evaluating 'document.getElementById('taboola_ad_script').getBoundingClientRect')",
    "undefined is not an object (evaluating 't.Domain')",
    "undefined is not an object (evaluating 'n.length')",
];
